import { DateUtil, request } from '@/utils/index';

const dateParser = new DateUtil();
export interface ArticleRequestsInterface {
  getLatestArticles: () => Promise<ArticlesAPICall>;
  getVideoArticles: () => Promise<ArticlesAPICall>;
  getArticles: () => Promise<Article[]>;
}

export interface ArticlesAPICall {
  last_rev: string;
  articles: Article[];
}

export interface Article {
  article_date: string;
  author: string;
  description: string;
  image: string;
  link: string;
  title: string;
  uuid: string;
  section?: string;
  sectionURL?: string;
}

const getLatestArticles = async () => {
  return await request('/blog/index.json', {});
};

const getVideoArticles = async () => {
  return await request('/video/index.json', {});
};

const getArticles = async () => {
  const articles = await Promise.all([
    loadAndProcessFirstArticle(
      '/car-buying/index.json',
      'Car buying',
      'https://www.bumper.com/car-buying/'
    ),
    loadAndProcessFirstArticle(
      '/car-selling/index.json',
      'Car selling',
      'https://www.bumper.com/car-selling/'
    ),
    loadAndProcessFirstArticle(
      '/car-advice/index.json',
      'Car advice',
      'https://www.bumper.com/car-advice/'
    ),
  ]);

  return articles.filter((article) => article !== undefined) as Article[];
};

const extractFirstArticle = async (
  articles: Article[],
  section: string,
  sectionURL: string
) => {
  if (!articles) {
    return;
  }

  const article = articles[0];
  article.article_date =
    dateParser.parseDateFromString(
      article.article_date,
      'MMM dd, yyyy',
      'EEE, dd MMM yyyy HH:mm:ss ZZZ'
    ) || '';

  return {
    section,
    sectionURL,
    ...article,
  };
};

const loadAndProcessFirstArticle = async (
  endpoint: string,
  title: string,
  url: string
) => {
  const result = await request(endpoint, {});
  return extractFirstArticle(result.articles, title, url);
};

export const ArticlesRequests = {
  getLatestArticles,
  getVideoArticles,
  getArticles,
};
